import React, {useState} from "react";
import "./Telegarph.css";
import RiddleCard from "../RiddleCard/RiddleCard";

const Telegraph = ({telegraphCurrentMessage, allSolved, subSolved, connected, overWriteFunction, index}) => {
    const getIcon = (letter) => {
        if(letter === 'k') {
            return <img className={"telegraph-image-small"} src={process.env.PUBLIC_URL + '/circle-solid.svg'} alt="on" />
        }
        else if(letter === 'l') {
            return <img className={"telegraph-image"} src={process.env.PUBLIC_URL + '/minus-solid.svg'} alt="off" />
        }
        return <p>\</p>
    };
    const getSolvedIcon = (state) => {
        if(state) {
            return <>
                <div className="scale-target-container">
                    <img className={"button-image"} src={process.env.PUBLIC_URL + '/check-square.svg'} alt="on" />
                </div></>
        }
        return <>
            <div className="scale-target-container">
                <img className={"button-image"} src={process.env.PUBLIC_URL + '/square.svg'} alt="off" />
            </div></>
    };
    const lookingFor = ['kl', 'lkkl'];
    const mainDiv = (
        <>
            <div className="telegraph-container">
                {Array.from(subSolved).map((status, index) => (
                    <div className={"solved-telegraph-container"} key={index}>
                        {getSolvedIcon(status)}
                        <div className="telegraph-message-container">
                            {Array.from(lookingFor[index]).map((letter, letterIndex) => (
                                <React.Fragment key={letterIndex}>
                                    {getIcon(letter)}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                ))}
                <div className="telegraph-message-container">
                    {Array.from(telegraphCurrentMessage).map((letter, index) => (
                        <React.Fragment key={index}>
                            {getIcon(letter)}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </>
    )

    return (
        <RiddleCard title={"Telegraph"} mainInfo={mainDiv} connected={connected} overwriteString={overWriteFunction} index={index}></RiddleCard>
    )
}

export default Telegraph;